'use client'

import { useEffect, useState } from 'react'
import { ComputerDesktopIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { useTranslations } from 'next-intl'

const STORAGE_KEY = 'desktopRecommendedBannerDismissed'
const SMALL_SCREEN_QUERY = '(max-width: 1024px)'

export default function DesktopRecommendedBanner() {
  const t = useTranslations('shared.desktopRecommendedBanner')
  const [dismissed, setDismissed] = useState(true)
  const [isSmallScreen, setIsSmallScreen] = useState(false)

  useEffect(() => {
    const stored = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null
    setDismissed(stored === '1')
  }, [])

  useEffect(() => {
    const mql = window.matchMedia(SMALL_SCREEN_QUERY)
    const update = () => setIsSmallScreen(mql.matches)
    update()
    mql.addEventListener('change', update)
    return () => mql.removeEventListener('change', update)
  }, [])

  if (dismissed || !isSmallScreen) return null

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1')
    setDismissed(true)
  }

  return (
    <div
      className="flex items-center justify-center gap-3 px-4 py-2 text-sm relative"
      style={{
        background: 'var(--color-lime-muted)',
        borderBottom: '1px solid var(--color-border)',
        color: 'var(--color-text-secondary)',
      }}
      role="status"
      aria-live="polite"
    >
      <ComputerDesktopIcon
        className="h-4 w-4 flex-shrink-0"
        style={{ color: 'var(--color-lime)' }}
      />
      <span>
        <span className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>
          {t('headingBold')}
        </span>{' '}
        {t('body')}
      </span>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label={t('dismiss')}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-md hover:opacity-70 transition-opacity"
        style={{ color: 'var(--color-text-muted)' }}
      >
        <XMarkIcon className="h-4 w-4" />
      </button>
    </div>
  )
}
